export const gender = [{ id: 1, label: 'Male' }, { id: 2, label: 'Female' }]

export const nationalities = [
  { id: 1, label: 'Afghanistan' },
  { id: 2, label: 'Albania' },
  { id: 3, label: 'Algeria' },
  { id: 4, label: 'American Samoa' },
  { id: 5, label: 'Andorra' },
  { id: 6, label: 'Angola' },
  { id: 7, label: 'Anguilla' },
  { id: 8, label: 'Antigua & Barbuda' },
  { id: 9, label: 'Argentina' },
  { id: 10, label: 'Armenia' },
  { id: 11, label: 'Aruba' },
  { id: 12, label: 'Australia' },
  { id: 13, label: 'Austria' },
  { id: 14, label: 'Azerbaijan' },
  { id: 15, label: 'Bahamas, The' },
  { id: 16, label: 'Bahrain' },
  { id: 17, label: 'Bangladesh' },
  { id: 18, label: 'Barbados' },
  { id: 19, label: 'Belarus' },
  { id: 20, label: 'Belgium' },
  { id: 21, label: 'Belize' },
  { id: 22, label: 'Benin' },
  { id: 23, label: 'Bermuda' },
  { id: 24, label: 'Bhutan' },
  { id: 25, label: 'Bolivia' },
  { id: 26, label: 'Bosnia & Herzegovina' },
  { id: 27, label: 'Botswana' },
  { id: 28, label: 'Brazil' },
  { id: 29, label: 'British Virgin Is.' },
  { id: 30, label: 'Brunei' },
  { id: 31, label: 'Bulgaria' },
  { id: 32, label: 'Burkina Faso' },
  { id: 33, label: 'Burma' },
  { id: 34, label: 'Burundi' },
  { id: 35, label: 'Cambodia' },
  { id: 36, label: 'Cameroon' },
  { id: 37, label: 'Canada' },
  { id: 38, label: 'Cape Verde' },
  { id: 39, label: 'Cayman Islands' },
  { id: 40, label: 'Central African Rep.' },
  { id: 41, label: 'Chad' },
  { id: 42, label: 'Chile' },
  { id: 43, label: 'China' },
  { id: 44, label: 'Colombia' },
  { id: 45, label: 'Comoros' },
  { id: 46, label: 'Congo, Dem. Rep.' },
  { id: 47, label: 'Congo, Repub. of the' },
  { id: 48, label: 'Cook Islands' },
  { id: 49, label: 'Costa Rica' },
  { id: 50, label: "Cote d'Ivoire" },
  { id: 51, label: 'Croatia' },
  { id: 52, label: 'Cuba' },
  { id: 53, label: 'Cyprus' },
  { id: 54, label: 'Czech Republic' },
  { id: 55, label: 'Denmark' },
  { id: 56, label: 'Djibouti' },
  { id: 57, label: 'Dominica' },
  { id: 58, label: 'Dominican Republic' },
  { id: 59, label: 'East Timor' },
  { id: 60, label: 'Ecuador' },
  { id: 61, label: 'Egypt' },
  { id: 62, label: 'El Salvador' },
  { id: 63, label: 'Equatorial Guinea' },
  { id: 64, label: 'Eritrea' },
  { id: 65, label: 'Estonia' },
  { id: 66, label: 'Ethiopia' },
  { id: 67, label: 'Faroe Islands' },
  { id: 68, label: 'Fiji' },
  { id: 69, label: 'Finland' },
  { id: 70, label: 'France' },
  { id: 71, label: 'French Guiana' },
  { id: 72, label: 'French Polynesia' },
  { id: 73, label: 'Gabon' },
  { id: 74, label: 'Gambia, The' },
  { id: 75, label: 'Gaza Strip' },
  { id: 76, label: 'Georgia' },
  { id: 77, label: 'Germany' },
  { id: 78, label: 'Ghana' },
  { id: 79, label: 'Gibraltar' },
  { id: 80, label: 'Greece' },
  { id: 81, label: 'Greenland' },
  { id: 82, label: 'Grenada' },
  { id: 83, label: 'Guadeloupe' },
  { id: 84, label: 'Guam' },
  { id: 85, label: 'Guatemala' },
  { id: 86, label: 'Guernsey' },
  { id: 87, label: 'Guinea' },
  { id: 88, label: 'Guinea-Bissau' },
  { id: 89, label: 'Guyana' },
  { id: 90, label: 'Haiti' },
  { id: 91, label: 'Honduras' },
  { id: 92, label: 'Hong Kong' },
  { id: 93, label: 'Hungary' },
  { id: 94, label: 'Iceland' },
  { id: 95, label: 'India' },
  { id: 96, label: 'Indonesia' },
  { id: 97, label: 'Iran' },
  { id: 98, label: 'Iraq' },
  { id: 99, label: 'Ireland' },
  { id: 100, label: 'Isle of Man' },
  { id: 101, label: 'Israel' },
  { id: 102, label: 'Italy' },
  { id: 103, label: 'Jamaica' },
  { id: 104, label: 'Japan' },
  { id: 105, label: 'Jersey' },
  { id: 106, label: 'Jordan' },
  { id: 107, label: 'Kazakhstan' },
  { id: 108, label: 'Kenya' },
  { id: 109, label: 'Kiribati' },
  { id: 110, label: 'Korea, North' },
  { id: 111, label: 'Korea, South' },
  { id: 112, label: 'Kuwait' },
  { id: 113, label: 'Kyrgyzstan' },
  { id: 114, label: 'Laos' },
  { id: 115, label: 'Latvia' },
  { id: 116, label: 'Lebanon' },
  { id: 117, label: 'Lesotho' },
  { id: 118, label: 'Liberia' },
  { id: 119, label: 'Libya' },
  { id: 120, label: 'Liechtenstein' },
  { id: 121, label: 'Lithuania' },
  { id: 122, label: 'Luxembourg' },
  { id: 123, label: 'Macau' },
  { id: 124, label: 'Macedonia' },
  { id: 125, label: 'Madagascar' },
  { id: 126, label: 'Malawi' },
  { id: 127, label: 'Malaysia' },
  { id: 128, label: 'Maldives' },
  { id: 129, label: 'Mali' },
  { id: 130, label: 'Malta' },
  { id: 131, label: 'Marshall Islands' },
  { id: 132, label: 'Martinique' },
  { id: 133, label: 'Mauritania' },
  { id: 134, label: 'Mauritius' },
  { id: 135, label: 'Mayotte' },
  { id: 136, label: 'Mexico' },
  { id: 137, label: 'Micronesia, Fed. St.' },
  { id: 138, label: 'Moldova' },
  { id: 139, label: 'Monaco' },
  { id: 140, label: 'Mongolia' },
  { id: 141, label: 'Montserrat' },
  { id: 142, label: 'Morocco' },
  { id: 143, label: 'Mozambique' },
  { id: 144, label: 'Namibia' },
  { id: 145, label: 'Nauru' },
  { id: 146, label: 'Nepal' },
  { id: 147, label: 'Netherlands' },
  { id: 148, label: 'Netherlands Antilles' },
  { id: 149, label: 'New Caledonia' },
  { id: 150, label: 'New Zealand' },
  { id: 151, label: 'Nicaragua' },
  { id: 152, label: 'Niger' },
  { id: 153, label: 'Nigeria' },
  { id: 154, label: 'N. Mariana Islands' },
  { id: 155, label: 'Norway' },
  { id: 156, label: 'Oman' },
  { id: 157, label: 'Pakistan' },
  { id: 158, label: 'Palau' },
  { id: 159, label: 'Panama' },
  { id: 160, label: 'Papua New Guinea' },
  { id: 162, label: 'Paraguay' },
  { id: 163, label: 'Peru' },
  { id: 164, label: 'Philippines' },
  { id: 165, label: 'Poland' },
  { id: 166, label: 'Portugal' },
  { id: 167, label: 'Puerto Rico' },
  { id: 168, label: 'Qatar' },
  { id: 169, label: 'Reunion' },
  { id: 170, label: 'Romania' },
  { id: 171, label: 'Russia' },
  { id: 172, label: 'Rwanda' },
  { id: 173, label: 'Saint Helena' },
  { id: 174, label: 'Saint Kitts & Nevis' },
  { id: 175, label: 'Saint Lucia' },
  { id: 176, label: 'St Pierre & Miquelon' },
  { id: 177, label: 'Saint Vincent and the Grenadines' },
  { id: 178, label: 'Samoa' },
  { id: 179, label: 'San Marino' },
  { id: 180, label: 'Sao Tome & Principe' },
  { id: 181, label: 'Saudi Arabia' },
  { id: 182, label: 'Senegal' },
  { id: 183, label: 'Serbia' },
  { id: 184, label: 'Seychelles' },
  { id: 185, label: 'Sierra Leone' },
  { id: 186, label: 'Singapore' },
  { id: 187, label: 'Slovakia' },
  { id: 188, label: 'Slovenia' },
  { id: 189, label: 'Solomon Islands' },
  { id: 190, label: 'Somalia' },
  { id: 191, label: 'South Africa' },
  { id: 192, label: 'Spain' },
  { id: 193, label: 'Sri Lanka' },
  { id: 194, label: 'Sudan' },
  { id: 195, label: 'Suriname' },
  { id: 196, label: 'Swaziland' },
  { id: 197, label: 'Sweden' },
  { id: 198, label: 'Switzerland' },
  { id: 199, label: 'Syria' },
  { id: 200, label: 'Taiwan' },
  { id: 201, label: 'Tajikistan' },
  { id: 202, label: 'Tanzania' },
  { id: 203, label: 'Thailand' },
  { id: 204, label: 'Togo' },
  { id: 205, label: 'Tonga' },
  { id: 206, label: 'Trinidad & Tobago' },
  { id: 207, label: 'Tunisia' },
  { id: 208, label: 'Turkey' },
  { id: 209, label: 'Turkmenistan' },
  { id: 210, label: 'Turks & Caicos Is' },
  { id: 211, label: 'Tuvalu' },
  { id: 212, label: 'Uganda' },
  { id: 213, label: 'Ukraine' },
  { id: 214, label: 'United Arab Emirates' },
  { id: 215, label: 'United Kingdom' },
  { id: 216, label: 'United States' },
  { id: 217, label: 'Uruguay' },
  { id: 218, label: 'Uzbekistan' },
  { id: 219, label: 'Vanuatu' },
  { id: 220, label: 'Venezuela' },
  { id: 221, label: 'Vietnam' },
  { id: 222, label: 'Virgin Islands' },
  { id: 223, label: 'Wallis and Futuna' },
  { id: 224, label: 'West Bank' },
  { id: 225, label: 'Western Sahara' },
  { id: 226, label: 'Yemen' },
  { id: 227, label: 'Zambia' },
  { id: 228, label: 'Zimbabwe' }
]

export const theirRole = [
  { id: 1, label: 'Area Manager' },
  { id: 2, label: 'Art Therapist' },
  { id: 3, label: 'Care Leader' },
  { id: 4, label: 'Care Worker' },
  { id: 5, label: 'Centre Manager' },
  { id: 6, label: 'Community Care Worker' },
  { id: 7, label: 'Coordinator' },
  { id: 8, label: 'Counsellor' },
  { id: 9, label: 'Deputy Centre Manager' },
  { id: 10, label: 'Deputy Director' },
  { id: 11, label: 'Deputy Social Care Manager' },
  { id: 12, label: 'Deputy Unit Manager' },
  { id: 13, label: 'Director' },
  { id: 14, label: 'Doctor - GP' },
  { id: 15, label: 'Doctor - Specialist' },
  { id: 16, label: 'EPIC Advocate' },
  { id: 17, label: 'Family Support Worker' },
  { id: 18, label: 'Garda' },
  { id: 19, label: 'Gardaí' },
  { id: 20, label: 'Guardian ad Litem' },
  { id: 21, label: 'HIQA Inspector' },
  { id: 22, label: 'Judge' },
  { id: 23, label: 'Monitoring Officer' },
  { id: 24, label: 'Ombudsman Official' },
  { id: 25, label: 'Organisation Owner' },
  { id: 26, label: 'Play Therapist ' },
  { id: 27, label: 'Principal Social Worker' },
  { id: 28, label: 'Psychiatrist' },
  { id: 29, label: 'Psychologist' },
  { id: 30, label: 'R & I Inspector' },
  { id: 31, label: 'Service Manager' },
  { id: 32, label: 'Shift Coordinator' },
  { id: 33, label: 'Social Care Leader' },
  { id: 34, label: 'Social Care Manager' },
  { id: 35, label: 'Social Care Student' },
  { id: 36, label: 'Social Care Trainee' },
  { id: 37, label: 'Social Care Worker' },
  { id: 38, label: 'Social Work Team Leader' },
  { id: 39, label: 'Social Worker' },
  { id: 40, label: 'Solicitor' },
  { id: 41, label: 'Team Lead' },
  { id: 42, label: 'Tusla Official' },
  { id: 43, label: 'Unit Manager' },
  { id: 44, label: 'YP Acquaintance' },
  { id: 45, label: 'YP Activity Friend(s)' },
  { id: 46, label: 'YP Brother(s) ' },
  { id: 47, label: 'YP Family' },
  { id: 48, label: 'YP Family Friend(s)' },
  { id: 49, label: 'YP Father' },
  { id: 50, label: 'YP Former Resident' },
  { id: 51, label: 'YP Friend(s)' },
  { id: 52, label: 'YP Mother' },
  { id: 53, label: 'YP Neighbour(s)' },
  { id: 54, label: 'YP Parents' },
  { id: 55, label: 'YP School Friend(s)' },
  { id: 56, label: 'YP Sister(s)' },
  { id: 57, label: 'Other' }
]

export const decision = [
  { id: 1, label: 'Yes' },
  { id: 2, label: 'No' },
  { id: 3, label: 'Pending' },
  { id: 4, label: 'N / A' }
]

export const trainingType = [
  { id: 1, label: 'Core Training' },
  { id: 2, label: 'Need Specific Training' }
]

export const trainingFrequency = [
  { id: 1, label: '6 Months' },
  { id: 2, label: '12 Months' },
  { id: 3, label: '18 Months' },
  { id: 4, label: '24 Months' },
  { id: 5, label: '30 Months' },
  { id: 6, label: '36 Months' },
  { id: 7, label: '42 Months' },
  { id: 8, label: '48 Months' },
  { id: 9, label: '54 Months' },
  { id: 10, label: '60 Months' }
]

export const activeStatus = [
  { value: 1, label: 'Active' },
  { value: 0, label: 'Inactive' }
]

export const userRole = [
  { value: 'Level 1', label: 'Level 1' },
  { value: 'Level 2', label: 'Level 2' },
  { value: 'Level 3', label: 'Level 3' }
]

export const editType = [
  { id: 1, label: 'Details Added', text: 'Add Details', icon: 'note_add' },
  { id: 2, label: 'Details Updated', text: 'Update Details', icon: 'update' },
  {
    id: 3,
    label: 'Details Corrected',
    text: 'Correct Details',
    icon: 'find_replace'
  },
  {
    id: 4,
    label: 'Record Deactivated',
    text: 'Deactivate Active Details',
    icon: 'lock'
  }
]



// WEBPACK FOOTER //
// ./src/common/constants.js